
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 233","fill":"#b1b6b9"}},[_c('path',{attrs:{"data-name":"Subtraction 1","d":"M13 14H1a1 1 0 01-1-1V1a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1zM4.111 1.166c-2.728 0-2.945 2.167-2.945 5v1.668c0 2.833.217 5 2.945 5l6.45.146a2.23 2.23 0 001.676-.555c.682-.7.65-2 .613-3.5-.009-.354-.018-.72-.018-1.094V6.167c0-.375.009-.74.018-1.092.036-1.442.066-2.686-.587-3.356a2.271 2.271 0 00-1.7-.552z"}}),_c('rect',{attrs:{"data-name":"Rectangle 44","width":"8","height":"8","rx":"2","transform":"translate(3 3)"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/hierarchy-treeview/CO.svg